export const INIT_AI_DOWNLOADS = 'app/containers/AIPhotoPage/INIT_AI_DOWNLOADS';
export const UPDATE_REMAINING_DOWNLOADS = 'app/containers/AIPhotoPage/UPDATE_REMAINING_DOWNLOADS';

export const GENERATE_AI_PHOTO = 'app/containers/AIPhotoPage/GENERATE_AI_PHOTO';
export const GENERATE_AI_PHOTO_REQUEST = 'app/containers/AIPhotoPage/GENERATE_AI_PHOTO_REQUEST';
export const GENERATE_AI_PHOTO_SUCCESS = 'app/containers/AIPhotoPage/GENERATE_AI_PHOTO_SUCCESS';
export const GENERATE_AI_PHOTO_ERROR = 'app/containers/AIPhotoPage/GENERATE_AI_PHOTO_ERROR';

export const DOWNLOAD_AI_PHOTO = 'app/containers/AIPhotoPage/DOWNLOAD_AI_PHOTO';
export const DOWNLOAD_AI_PHOTO_SUCCESS = 'app/containers/AIPhotoPage/DOWNLOAD_AI_PHOTO_SUCCESS';
export const DOWNLOAD_AI_PHOTO_ERROR = 'app/containers/AIPhotoPage/DOWNLOAD_AI_PHOTO_ERROR';
